import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

function WarningIcon(
  props: Readonly<SvgIconProps & { disabled?: boolean; iconColor?: string }>,
): JSX.Element {
  const color = props.disabled ? '#AAAAAA' : props.iconColor;
  const width = 2;

  return (
    <SvgIcon viewBox='0 -960 960 960' {...props}>
      <path
        d='m40-120 440-760 440 760H40Zm440-120q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Z'
        fill={color}
        stroke={color}
        strokeWidth={width}
        strokeLinejoin='round'
        strokeLinecap='round'
        className={props.className}
      />
    </SvgIcon>
  );
}

export default React.memo(WarningIcon);
